import React from "react"
import tinycolor from 'tinycolor2'

const Cpoe = ({cpoe, rem}) => {

    // func for imperceisely handling float-point rounding hell //
    function truncate (num, places) {
        return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
    }

    var parsedCpoe = parseFloat(cpoe)

    // colors //
    const pos_color = '#e8fcf6'
    const mid_color = '#ffffff'
    const neg_color = '#ffe6ef'

    // default styles //
    var displayStyle = {
        width: '80%',
        height: '65%',
        margin: '0 auto',
        borderRadius: '15px',
        background: 'white',
        color: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        fontSize: rem,
        fontWeight: 400,
    }

    // set color styles //
    if (isNaN(parsedCpoe)) {

        // grey //
        displayStyle['color'] = '#ababab'

    } else if (parsedCpoe >= 0) {
        
        // positive color //
        displayStyle['background'] = tinycolor.mix(mid_color, pos_color, 100 * parsedCpoe / 10)
        displayStyle['color'] = '#259c72'
 
    } else if (parsedCpoe < 0) {
       
       // negative color //
       displayStyle['background'] = tinycolor.mix(mid_color, neg_color, -100 * parsedCpoe / 10)
       displayStyle['color'] = '#bf2a5e'

    }

    return (
        <div
            style={displayStyle}
        >
            {isNaN(parsedCpoe) ? '--' : `${truncate(parsedCpoe,1)}%`}
        </div>
    )

}

export default Cpoe